import useResponsiveRedux from '../Hooks/useResponsiveRedux';
import SingleWrestlerMobilePage from '../../pages/Mobile/SingleWrestlerMobilePage';
import Wrestler from '../../pages/Wrestler';

const SingleWrestlerResponsive = () => {
    const { isMobile } = useResponsiveRedux();

    return isMobile ? <SingleWrestlerMobilePage /> : <Wrestler />;
};

export default SingleWrestlerResponsive;